// extracted by mini-css-extract-plugin
module.exports = {"siteLayoutBackground":"site-layout-background[Frida]3E_qyCvJ"};